import { httpRequest } from "../../http";

export class CommandUpdateTeamMemberProfilePicture {

    async run(organizationId: number,  employeeId: number, profilePicture: File) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organization/${organizationId}/team/${employeeId}/profile-picture/`
        try {
            const formData = new FormData();
            if(profilePicture) {
                formData.append("file", profilePicture, profilePicture.name);
            }
            
            const response = await httpRequest<any>(url, { method: "PATCH", body: profilePicture ? formData : {file: null} });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }


  
}
